/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Organization policy for automatic remote-session refresh
 */
export const SetRemoteSessionAutoRefreshPolicyRequestBodyPolicy = {
  Disabled: "disabled",
  UserControlled: "user_controlled",
  Enforced: "enforced",
} as const;
/**
 * Organization policy for automatic remote-session refresh
 */
export type SetRemoteSessionAutoRefreshPolicyRequestBodyPolicy = ClosedEnum<
  typeof SetRemoteSessionAutoRefreshPolicyRequestBodyPolicy
>;

export type SetRemoteSessionAutoRefreshPolicyRequestBody = {
  /**
   * Organization whose automatic remote-session refresh policy to update.
   */
  organizationId: string;
  /**
   * Organization policy for automatic remote-session refresh
   */
  policy: SetRemoteSessionAutoRefreshPolicyRequestBodyPolicy;
};

/** @internal */
export const SetRemoteSessionAutoRefreshPolicyRequestBodyPolicy$outboundSchema:
  z.ZodMiniEnum<typeof SetRemoteSessionAutoRefreshPolicyRequestBodyPolicy> = z
    .enum(SetRemoteSessionAutoRefreshPolicyRequestBodyPolicy);

/** @internal */
export type SetRemoteSessionAutoRefreshPolicyRequestBody$Outbound = {
  organization_id: string;
  policy: string;
};

/** @internal */
export const SetRemoteSessionAutoRefreshPolicyRequestBody$outboundSchema:
  z.ZodMiniType<
    SetRemoteSessionAutoRefreshPolicyRequestBody$Outbound,
    SetRemoteSessionAutoRefreshPolicyRequestBody
  > = z.pipe(
    z.object({
      organizationId: z.string(),
      policy: SetRemoteSessionAutoRefreshPolicyRequestBodyPolicy$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        organizationId: "organization_id",
      });
    }),
  );

export function setRemoteSessionAutoRefreshPolicyRequestBodyToJSON(
  setRemoteSessionAutoRefreshPolicyRequestBody:
    SetRemoteSessionAutoRefreshPolicyRequestBody,
): string {
  return JSON.stringify(
    SetRemoteSessionAutoRefreshPolicyRequestBody$outboundSchema.parse(
      setRemoteSessionAutoRefreshPolicyRequestBody,
    ),
  );
}
